/**
 * A to Z Auto Parts India - Main Application Script
 * Handles dynamic content rendering, interactions, and animations.
 */

// ============================================================
// DATA LAYER
// ============================================================

const PRODUCT_IMAGES = {
  engine: '//atozautopartsindia.com/cdn/shop/t/15/assets/car-engine.png?v=228689',
  brake: '//atozautopartsindia.com/cdn/shop/t/15/assets/brake-system.png?v=228689',
  wheel: '//atozautopartsindia.com/cdn/shop/t/15/assets/alloy-wheel.png?v=228689',
  interior: '//atozautopartsindia.com/cdn/shop/t/15/assets/car-interior.png?v=228689',
  hero: '//atozautopartsindia.com/cdn/shop/t/15/assets/hero-car.png?v=228689',
};


  // Products are now rendered directly via Liquid in index.liquid.

const brands = [
  { name: 'BMW', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/bmw_car.png?v=228689" alt="BMW">', count: '0 Parts' },
  { name: 'Mercedes-Benz', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/mercedes_car.png?v=228689" alt="Mercedes-Benz">', count: '0 Parts' },
  { name: 'Audi', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/audi_car.png?v=228689" alt="Audi">', count: '0 Parts' },
  { name: 'Jaguar', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/jaguar_car.png?v=228689" alt="Jaguar">', count: '0 Parts' },
  { name: 'Land Rover', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/land_rover_car.png?v=228689" alt="Land Rover">', count: '0 Parts' },
  { name: 'Porsche', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/porsche_car.png?v=228689" alt="Porsche">', count: '0 Parts' },
];








const categories = [
  { name: 'Engine Parts', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/engine_parts.png?v=228689" alt="Engine Parts">', count: '18,000+ items', url: '#' },
  { name: 'Brakes & Rotors', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/brakes_rotors.png?v=228689" alt="Brakes">', count: '4,200+ items', url: '#' },
  { name: 'Suspension', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/suspension_parts.png?v=228689" alt="Suspension">', count: '6,500+ items', url: '#' },
  { name: 'Electrical', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/car_battery.png?v=228689" alt="Electrical">', count: '8,100+ items', url: '#' },
  { name: 'Body Panels', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/audi_car.png?v=228689" alt="Body Panels">', count: '12,300+ items', url: '#' },
  { name: 'Lighting', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/car_headlight.png?v=228689" alt="Lighting">', count: '5,700+ items', url: '#' },
  { name: 'Interior', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/windshield_wipers.png?v=228689" alt="Interior">', count: '7,400+ items', url: '#' },
  { name: 'Wheels & Tires', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/brakes_rotors.png?v=228689" alt="Wheels">', count: '3,900+ items', url: '#' },
  { name: 'Exhaust', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/clutch_kit.png?v=228689" alt="Exhaust">', count: '2,800+ items', url: '#' },
  { name: 'Filters & Fluids', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/engine_oil.png?v=228689" alt="Filters">', count: '9,200+ items', url: '#' },
];


const keyCategories = [
  { name: 'Engine Oil', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/engine_oil.png?v=228689" alt="Engine Oil">' },
  { name: 'Brake Pads', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/brake_pads.png?v=228689" alt="Brake Pads">' },
  { name: 'Air Filters', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/air_filters.png?v=228689" alt="Air Filters">' },
  { name: 'Spark Plugs', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/spark_plugs.png?v=228689" alt="Spark Plugs">' },
  { name: 'Batteries', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/car_battery.png?v=228689" alt="Batteries">' },
  { name: 'Wipers', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/windshield_wipers.png?v=228689" alt="Wipers">' },
  { name: 'Headlights', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/car_headlight.png?v=228689" alt="Headlights">' },
  { name: 'Clutch Kits', icon: '<img src="//atozautopartsindia.com/cdn/shop/t/15/assets/clutch_kit.png?v=228689" alt="Clutch Kits">' },
];

// ============================================================
// UTILITY FUNCTIONS
// ============================================================

function formatPrice(price) {
  if (typeof price !== 'number') return price;
  return 'Rs. ' + price.toLocaleString('en-IN');
}

function generateStars(rating) {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5 ? 1 : 0;
  const empty = 5 - full - half;
  return '★'.repeat(full) + (half ? '★' : '') + '☆'.repeat(empty);
}

// Products are now rendered directly via Liquid template.

function renderBrands() {
  const grid = document.getElementById('brands-grid');
  if (!grid) return;
  grid.innerHTML = brands
    .map(
      (brand) => `
    <div class="brand-card animate-on-scroll">
      <div class="brand-card-icon">${brand.icon}</div>
      <h3>${brand.name}</h3>
      <p>${brand.count}</p>
    </div>
  `
    )
    .join('');
}

function renderCategories() {
  const grid = document.getElementById('categories-grid');
  if (!grid) return;
  grid.innerHTML = categories
    .map(
      (cat) => `
    <a href="${cat.url || '#'}" class="category-card animate-on-scroll" style="text-decoration: none; color: inherit; display: flex; flex-direction: column; align-items: center; justify-content: center;">
      <div class="category-icon">${cat.icon}</div>
      <h3>${cat.name}</h3>
      <span class="count">${cat.count}</span>
    </a>
  `
    )
    .join('');
}

function renderKeyCategories() {
  const grid = document.getElementById('key-cats-grid');
  if (!grid) return;
  grid.innerHTML = keyCategories
    .map(
      (cat) => `
    <div class="key-cat-item animate-on-scroll">
      <span class="icon">${cat.icon}</span>
      <span>${cat.name}</span>
    </div>
  `
    )
    .join('');
}

// ============================================================
// COUNTDOWN TIMER
// ============================================================

function startCountdown() {
  // Set countdown to 8 hours, 42 mins, 15 secs from now
  let totalSeconds = 8 * 3600 + 42 * 60 + 15;

  function updateDisplay() {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const hoursEl = document.getElementById('countdown-hours');
    const minsEl = document.getElementById('countdown-minutes');
    const secsEl = document.getElementById('countdown-seconds');

    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
    if (minsEl) minsEl.textContent = String(minutes).padStart(2, '0');
    if (secsEl) secsEl.textContent = String(seconds).padStart(2, '0');

    if (totalSeconds > 0) {
      totalSeconds--;
    } else {
      totalSeconds = 8 * 3600 + 42 * 60 + 15; // Reset
    }
  }

  updateDisplay();
  setInterval(updateDisplay, 1000);
}

// ============================================================
// SCROLL ANIMATIONS (Intersection Observer)
// ============================================================

function initScrollAnimations() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    }
  );

  document.querySelectorAll('.animate-on-scroll').forEach((el) => {
    observer.observe(el);
  });
}

// ============================================================
// HEADER SCROLL EFFECT
// ============================================================

function initHeaderScroll() {
  const header = document.getElementById('header');
  if (!header) return;

  // Calculate and set dynamic header height for sticky elements
  const updateHeaderHeight = () => {
    document.documentElement.style.setProperty('--dynamic-header-height', `${header.offsetHeight}px`);
    const headerMain = document.querySelector('.header-main');
    if (headerMain) {
      document.documentElement.style.setProperty('--header-main-height', `${headerMain.offsetHeight}px`);
    }
  };
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight, { passive: true });

  let lastScroll = 0;

  window.addEventListener(
    'scroll',
    () => {
      const currentScroll = window.scrollY;

      if (currentScroll > 80) {
        if (!header.classList.contains('scrolled')) {
          header.classList.add('scrolled');
        }
      } else {
        if (header.classList.contains('scrolled')) {
          header.classList.remove('scrolled');
        }
      }
      // Hide header on scroll down, show on scroll up (all devices)
      const stickySearchOverlay = document.getElementById('sticky-search-overlay');
      const isStickySearchOpen = stickySearchOverlay && !stickySearchOverlay.classList.contains('hidden');
      const searchBar = document.getElementById('search-bar');
      const isMobileSearchOpen = searchBar && searchBar.classList.contains('mobile-active');

      if (currentScroll > 150) {
        if (currentScroll > lastScroll && currentScroll > header.offsetHeight && !isStickySearchOpen && !isMobileSearchOpen) {
          header.classList.add('header-hidden');
          document.body.classList.add('header-hidden-state');
        } else {
          header.classList.remove('header-hidden');
          document.body.classList.remove('header-hidden-state');
        }
      } else {
        header.classList.remove('header-hidden');
        document.body.classList.remove('header-hidden-state');
      }
      
      lastScroll = currentScroll <= 0 ? 0 : currentScroll;
      // Filter bar sticky logic
      const normalFilterBar = document.querySelector('.mobile-filter-sort-bar-normal');
      if (normalFilterBar) {
        // Offset by a little bit to ensure smooth transition
        if (currentScroll > normalFilterBar.offsetTop - 50) {
          document.body.classList.add('past-filter-bar');
        } else {
          document.body.classList.remove('past-filter-bar');
        }
      }

      lastScroll = currentScroll <= 0 ? 0 : currentScroll;
    },
    { passive: true }
  );
}

// ============================================================
// SCROLL TO TOP
// ============================================================

function initScrollTop() {
  const btn = document.getElementById('scroll-top');
  const contactWidget = document.querySelector('.floating-contact-widget');
  if (!btn) return;

  window.addEventListener(
    'scroll',
    () => {
      if (window.scrollY > 300) {
        btn.classList.add('visible');
        if (contactWidget) contactWidget.classList.add('shifted');
      } else {
        btn.classList.remove('visible');
        if (contactWidget) contactWidget.classList.remove('shifted');
      }
    },
    { passive: true }
  );

  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

// ============================================================
// PRODUCT TAB SWITCHING
// ============================================================

function initProductTabs() {
  function filterGrid(gridId, filter) {
    const grid = document.getElementById(gridId);
    if (!grid) return;
    
    // Reset scroll position to start
    grid.scrollTo({ left: 0, behavior: 'smooth' });
    
    const cards = grid.querySelectorAll('.product-card');
    cards.forEach((card, i) => {
      if (filter === 'all' || (card.dataset.tab && (card.dataset.tab.includes(filter) || filter.includes(card.dataset.tab)))) {
        card.style.display = 'flex'; // Or flex if that's what's used
        card.style.opacity = '0';
        card.style.transform = 'translateY(10px)';
        setTimeout(() => {
          card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        }, 10 * i);
      } else {
        card.style.display = 'none';
      }
    });
    // Trigger arrow update
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 50);
  }

  // Popular tabs
  const popularTabsContainer = document.getElementById('popular-tabs');
  if (popularTabsContainer) {
    popularTabsContainer.addEventListener('click', (e) => {
      const tab = e.target.closest('.product-tab');
      if (!tab) return;
      popularTabsContainer.querySelectorAll('.product-tab').forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');
      filterGrid('popular-products-grid', tab.dataset.tab);
      
      const link = tab.dataset.tab === 'all' ? '/collections/all' : '/collections/' + tab.dataset.tab;
      const btnDesktop = document.getElementById('popular-view-all');
      const btnMobile = document.getElementById('popular-view-all-mobile');
      if (btnDesktop) btnDesktop.href = link;
      if (btnMobile) btnMobile.href = link;
    });
  }

  // Trending tabs
  const trendingTabsContainer = document.getElementById('trending-tabs');
  if (trendingTabsContainer) {
    trendingTabsContainer.addEventListener('click', (e) => {
      const tab = e.target.closest('.product-tab');
      if (!tab) return;
      trendingTabsContainer.querySelectorAll('.product-tab').forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');
      filterGrid('trending-products-grid', tab.dataset.tab);
      
      const link = tab.dataset.tab === 'all' ? '/collections/all' : '/collections/' + tab.dataset.tab;
      const btnDesktop = document.getElementById('trending-view-all');
      const btnMobile = document.getElementById('trending-view-all-mobile');
      if (btnDesktop) btnDesktop.href = link;
      if (btnMobile) btnMobile.href = link;
    });
  }
}

// ============================================================
// ACTIVE NAV LINK ON SCROLL
// ============================================================

function initActiveNavLink() {
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.nav-link[data-section]');

  if (!sections.length || !navLinks.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          navLinks.forEach((link) => {
            link.classList.toggle(
              'active',
              link.dataset.section === sectionId
            );
          });
        }
      });
    },
    {
      threshold: 0.2,
      rootMargin: '-100px 0px -50% 0px',
    }
  );

  sections.forEach((section) => observer.observe(section));
}

// ============================================================
// SMOOTH SCROLL FOR NAV LINKS
// ============================================================

function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href').slice(1);
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        const headerOffset = 120;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    });
  });
}

// ============================================================
// NEWSLETTER FORM
// ============================================================

function initNewsletter() {
  const form = document.getElementById('newsletter-form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const emailInput = document.getElementById('newsletter-email');
    const submitBtn = document.getElementById('newsletter-submit');

    if (emailInput && emailInput.value) {
      const originalText = submitBtn.textContent;
      submitBtn.textContent = '✓ Subscribed!';
      submitBtn.style.background = '#10B981';
      submitBtn.style.color = 'white';
      emailInput.value = '';

      setTimeout(() => {
        submitBtn.textContent = originalText;
        submitBtn.style.background = '';
        submitBtn.style.color = '';
      }, 3000);
    }
  });
}

// ============================================================
// SEARCH FORM
// ============================================================

function initSearch() {
  setupPredictiveSearch('search-form', 'search-input', 'predictive-search-results', 'search-clear-btn');
  setupPredictiveSearch('sticky-search-form', 'sticky-search-input', 'sticky-predictive-search-results', null);
  setupPredictiveSearch('page-search-form', 'page-search-input', 'page-predictive-search-results', null);
}

function setupPredictiveSearch(formId, inputId, resultsId, clearBtnId) {
  const form = document.getElementById(formId);
  const input = document.getElementById(inputId);
  const resultsContainer = document.getElementById(resultsId);
  const clearBtn = clearBtnId ? document.getElementById(clearBtnId) : null;
  if (!form || !input || !resultsContainer) return;

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.style.display = 'none';
      resultsContainer.classList.remove('active');
      resultsContainer.innerHTML = '';
      input.focus();
    });
  }

  function showSearchHistory() {
    const history = JSON.parse(localStorage.getItem('atoz_search_history') || '[]');
    if (history.length === 0) {
      resultsContainer.classList.remove('active');
      resultsContainer.innerHTML = '';
      return;
    }
    
    let html = '<div class="predictive-search-history-header" style="padding: 10px 16px; font-size: 12px; color: #777; text-transform: uppercase; font-weight: 600;">Recent Searches</div>';
    history.forEach(item => {
      const safeItem = item.replace(/'/g, "\\'");
      html += `
        <div class="predictive-search-history-item" style="padding: 10px 16px; cursor: pointer; display: flex; align-items: center; gap: 10px;" onclick="document.getElementById('${inputId}').value='${safeItem}'; const f = document.getElementById('${formId}'); const b = f.querySelector('button[type=submit]'); if(b) b.click(); else f.submit();">
          <i class="fa-solid fa-clock-rotate-left" style="color: #aaa;"></i>
          <span class="history-term" style="font-size: 14px; color: var(--color-text-primary);">${item}</span>
        </div>
      `;
    });
    
    resultsContainer.classList.add('active');
    resultsContainer.innerHTML = html;
  }

  form.addEventListener('submit', (e) => {
    const query = input.value.trim();
    if (!query) {
      e.preventDefault(); // Don't submit if empty
      return;
    }
    
    let history = JSON.parse(localStorage.getItem('atoz_search_history') || '[]');
    history = history.filter(item => item.toLowerCase() !== query.toLowerCase());
    history.unshift(query);
    if (history.length > 5) history.pop();
    localStorage.setItem('atoz_search_history', JSON.stringify(history));

    const categoryInput = document.getElementById('search-category');
    if (categoryInput && !categoryInput.disabled && categoryInput.value && categoryInput.value !== 'all') {
      e.preventDefault();
      const finalQuery = query + ' ' + categoryInput.value;
      window.location.href = `/search?type=product&q=${encodeURIComponent(finalQuery)}&options%5Bprefix%5D=last`;
    }
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length === 0) {
      showSearchHistory();
    }
  });
  
  input.addEventListener('click', () => {
    if (input.value.trim().length === 0) {
      showSearchHistory();
    }
  });

  let debounceTimer;

  input.addEventListener('input', (e) => {
    clearTimeout(debounceTimer);
    const query = e.target.value.trim();

    if (clearBtn) {
      clearBtn.style.display = query.length > 0 ? 'flex' : 'none';
    }

    if (query.length === 0) {
      showSearchHistory();
      return;
    }

    resultsContainer.classList.add('active');
    resultsContainer.innerHTML = '<div class="predictive-search-loading"><i class="predictive-search-fa-spinner fa-solid fa-spinner"></i></div>';

    debounceTimer = setTimeout(() => {
      let finalQuery = query;
      const categoryInput = document.getElementById('search-category');
      if (categoryInput && !categoryInput.disabled && categoryInput.value && categoryInput.value !== 'all') {
        finalQuery = query + ' ' + categoryInput.value;
      }

      fetch(`/search/suggest.json?q=${encodeURIComponent(finalQuery)}&resources[type]=product&resources[limit]=10`)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(data => {
          const products = data.resources.results.products;
          
          if (!products || products.length === 0) {
            resultsContainer.innerHTML = '<div class="predictive-search-empty">No products found for "' + query + '"</div>';
            return;
          }

          let html = '';
          products.forEach(product => {
            const imageHtml = product.image ? `<img src="${product.image}" alt="${product.title}" class="predictive-search-item-image">` : '<div class="predictive-search-item-image" style="background:#eee;"></div>';
            const priceNum = parseFloat(product.price.replace(/[^0-9.]/g, ''));
            const formattedPrice = isNaN(priceNum) ? (product.price ? product.price.replace('$', 'Rs. ') : '') : 'Rs. ' + Math.floor(priceNum).toLocaleString('en-IN');
            
            html += `
              <a href="${product.url}" class="predictive-search-item">
                ${imageHtml}
                <div class="predictive-search-item-info">
                  <span class="predictive-search-item-title">${product.title}</span>
                  <span class="predictive-search-item-price">${formattedPrice}</span>
                </div>
              </a>
            `;
          });
          resultsContainer.innerHTML = html;
        })
        .catch(error => {
          console.error('Error fetching predictive search:', error);
          resultsContainer.innerHTML = '<div class="predictive-search-empty">Error loading suggestions</div>';
        });
    }, 300);
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (!form.contains(e.target) && !resultsContainer.contains(e.target)) {
      resultsContainer.classList.remove('active');
    }
  });
  
  // Re-open on focus if it has content
  input.addEventListener('focus', () => {
    if (input.value.trim().length > 0 && resultsContainer.innerHTML.trim() !== '') {
      resultsContainer.classList.add('active');
    }
  });
}

function initCustomDropdown() {
  // Search Category Dropdown
  const searchDropdown = document.getElementById('search-category-dropdown');
  const searchTrigger = document.getElementById('dropdown-trigger');
  const searchOptions = document.getElementById('dropdown-options');
  const selectedText = document.getElementById('dropdown-selected-text');
  const hiddenSelect = document.getElementById('search-category');

  if (searchDropdown && searchTrigger && searchOptions) {
    searchTrigger.addEventListener('click', (e) => {
      e.stopPropagation();
      searchDropdown.classList.toggle('open');
      // Close shop dropdown if open
      const shopDropdown = document.getElementById('shop-category-dropdown');
      if (shopDropdown) shopDropdown.classList.remove('open');
    });

    searchOptions.addEventListener('click', (e) => {
      const option = e.target.closest('.dropdown-option');
      if (!option) return;

      if (selectedText) {
        const text = option.textContent.trim();
        const words = text.split(' ');
        if (words.length > 2) {
          selectedText.textContent = words.slice(0, 2).join(' ') + '...';
        } else {
          selectedText.textContent = text;
        }
      }
      if (hiddenSelect) {
        hiddenSelect.value = option.dataset.value;
        if (option.dataset.value === 'all') {
          hiddenSelect.disabled = true;
        } else {
          hiddenSelect.disabled = false;
        }
      }

      searchDropdown.querySelectorAll('.dropdown-option').forEach(opt => opt.classList.remove('selected'));
      option.classList.add('selected');

      searchDropdown.classList.remove('open');
    });
    
    const searchForm = document.getElementById('search-form');
    if (searchForm) {
      searchForm.addEventListener('submit', (e) => {
        const qInput = document.getElementById('search-input');
        if (qInput && !qInput.value.trim() && hiddenSelect && !hiddenSelect.disabled && hiddenSelect.value !== 'all') {
          e.preventDefault();
          window.location.href = `/collections/all?custom_category=${encodeURIComponent(hiddenSelect.value)}`;
        }
      });
    }
  }

  // Shop By Category Dropdown
  const shopDropdown = document.getElementById('shop-category-dropdown');
  const shopTrigger = document.getElementById('shop-dropdown-trigger');
  const shopOptions = document.getElementById('shop-dropdown-options');

  if (shopDropdown && shopTrigger && shopOptions) {
    shopTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      shopDropdown.classList.toggle('open');
      document.body.style.overflow = shopDropdown.classList.contains('open') ? 'hidden' : '';
      // Close search dropdown if open
      if (searchDropdown) searchDropdown.classList.remove('open');
    });
    
    // Allow clicking links inside to navigate and close
    shopOptions.addEventListener('click', (e) => {
      const option = e.target.closest('.dropdown-option');
      if (option) {
        // Don't close if it's a mobile submenu toggle (has a submenu inside parent)
        if (window.innerWidth < 1180 && option.parentElement.classList.contains('has-submenu')) {
          return;
        }
        shopDropdown.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (searchDropdown && !searchDropdown.contains(e.target)) {
      searchDropdown.classList.remove('open');
    }
    if (shopDropdown && !shopDropdown.contains(e.target)) {
      if (shopDropdown.classList.contains('open')) {
        shopDropdown.classList.remove('open');
        document.body.style.overflow = '';
      }
    }
  });
}

// ============================================================
// ADD TO CART INTERACTIONS
// ============================================================

function initCartInteractions() {
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form');
    if (!form || !form.getAttribute('action') || !form.getAttribute('action').includes('/cart/add')) return;
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const addBtn = form.querySelector('button[type="submit"]') || form.querySelector('.btn-primary');
    if (!addBtn) return;

    if (addBtn.disabled) return;

    const originalText = addBtn.innerHTML;
    
    // Loading State
    addBtn.innerHTML = `<i class="fa-solid fa-spinner" style="animation: spin 1s linear infinite; display: inline-block; vertical-align: middle; margin-right: 8px;"></i> Adding...`;
    addBtn.disabled = true;
    addBtn.style.opacity = '0.8';

    // Deduplicate 'id' in FormData to prevent Shopify adding multiple items
    const formData = new FormData(form);
    const payload = new FormData();
    let idAdded = false;
    for (let [key, value] of formData.entries()) {
      if (key === 'id') {
        if (!idAdded) {
          payload.append(key, value);
          idAdded = true;
        }
      } else {
        payload.append(key, value);
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: payload
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => { throw new Error(err.description || 'Error adding to cart'); });
      }
      return response.json();
    })
    .then(() => {
      // Success State
      addBtn.innerHTML = '✓ Added';
      addBtn.style.background = '#10B981';
      addBtn.style.opacity = '1';
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(cart => {
      const cartCounts = document.querySelectorAll('.cart-count-badge');
      if (cartCounts.length > 0) {
        cartCounts.forEach(cartCount => {
          cartCount.textContent = cart.item_count || 0;
          cartCount.style.transform = 'scale(1.3)';
          setTimeout(() => {
            cartCount.style.transform = 'scale(1)';
          }, 300);
        });
      }
      if (typeof updateCartDrawer === 'function') {
        updateCartDrawer();
        openCartDrawer();
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      addBtn.innerHTML = 'Error';
      addBtn.style.background = '#EF4444';
    })
    .finally(() => {
      setTimeout(() => {
        addBtn.innerHTML = originalText;
        addBtn.style.background = '';
        addBtn.style.opacity = '';
        addBtn.disabled = false;
      }, 2000);
    });
  });

  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('.ajax-cart-remove');
    if (!removeBtn) return;
    
    e.preventDefault();
    const url = removeBtn.href;
    const row = removeBtn.closest('tr');
    if (row) row.style.opacity = '0.5';

    fetch(url)
      .then(() => fetch('/cart'))
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newCartPage = doc.querySelector('.cart-page');
        const currentCartPage = document.querySelector('.cart-page');
        if (newCartPage && currentCartPage) {
          currentCartPage.innerHTML = newCartPage.innerHTML;
        }

        return fetch('/cart.js');
      })
      .then(res => res.json())
      .then(cart => {
        const cartCounts = document.querySelectorAll('.cart-count-badge');
        if (cartCounts.length > 0) {
          cartCounts.forEach(cartCount => {
            cartCount.textContent = cart.item_count || 0;
            cartCount.style.transform = 'scale(1.3)';
            setTimeout(() => cartCount.style.transform = 'scale(1)', 300);
          });
        }
      })
      .catch(error => {
        console.error('Error removing cart item:', error);
        window.location.href = url;
      });
  });
}

// ============================================================
// WISHLIST INTERACTIONS
// ============================================================

function getWishlist() {
  const wishlist = localStorage.getItem('a2z_wishlist');
  return wishlist ? JSON.parse(wishlist) : [];
}

function saveWishlist(wishlist) {
  localStorage.setItem('a2z_wishlist', JSON.stringify(wishlist));
  updateWishlistCount(wishlist.length);
}

function updateWishlistCount(count) {
  const wishlistCount = document.querySelector('#wishlist-btn .count');
  if (wishlistCount) {
    wishlistCount.textContent = count;
  }
}

function initWishlistInteractions() {
  const wishlist = getWishlist();
  updateWishlistCount(wishlist.length);
  
  // Highlight buttons for items already in wishlist
  document.querySelectorAll('.product-card-actions button[aria-label="Add to wishlist"]').forEach(btn => {
    const handle = btn.dataset.productHandle;
    if (handle && wishlist.includes(handle)) {
      btn.classList.add('active');
      btn.innerHTML = '<i class="heart-icon fa-solid fa-heart" style="margin-top: 2px;"></i>';
    }
  });

  document.addEventListener('click', (e) => {
    const wishBtn = e.target.closest('.product-card-actions button[aria-label="Add to wishlist"]');
    if (!wishBtn) return;
    
    e.preventDefault();
    e.stopPropagation();

    const handle = wishBtn.dataset.productHandle;
    if (!handle) return;
    
    let currentWishlist = getWishlist();

    if (!wishBtn.classList.contains('active')) {
      wishBtn.classList.add('active');
      wishBtn.innerHTML = '<i class="heart-icon fa-solid fa-heart" style="margin-top: 2px;"></i>';
      wishBtn.style.transform = 'scale(1.2)';
      
      if (!currentWishlist.includes(handle)) {
        currentWishlist.push(handle);
        saveWishlist(currentWishlist);
      }
    } else {
      wishBtn.classList.remove('active');
      wishBtn.innerHTML = '<i class="heart-icon fa-regular fa-heart" style="margin-top: 2px;"></i>';
      wishBtn.style.transform = 'scale(1)';
      
      currentWishlist = currentWishlist.filter(h => h !== handle);
      saveWishlist(currentWishlist);
      
      // If we are on the wishlist page, we should remove the card
      if (window.location.pathname.includes('/pages/wishlist')) {
        const card = wishBtn.closest('.product-card');
        if (card) {
          card.remove();
          if (currentWishlist.length === 0) {
            const grid = document.querySelector('#wishlist-grid');
            if (grid) {
              grid.innerHTML = '<div style="grid-column: 1/-1; text-align: center; padding: 4rem 0;"><p>Your wishlist is empty.</p><a href="/collections/all" class="btn btn-primary" style="margin-top: 1rem;">Continue Shopping</a></div>';
            }
          }
        }
      }
    }

    setTimeout(() => {
      wishBtn.style.transform = '';
    }, 200);
  });
}

// ============================================================
// QUICK VIEW INTERACTIONS
// ============================================================

function initQuickViewInteractions() {
  const modal = document.getElementById('quick-view-modal');
  const closeBtn = document.getElementById('close-quick-view');
  const modalBody = document.getElementById('quick-view-body');

  if (!modal || !closeBtn || !modalBody) return;

  document.addEventListener('click', (e) => {
    const quickViewBtn = e.target.closest('.quick-view-link');
    if (!quickViewBtn) return;
    
    e.preventDefault();

    const handle = quickViewBtn.dataset.productHandle;
    if (!handle) return;

    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    modalBody.innerHTML = '<div style="text-align:center; padding:3rem;"><i class="fa-solid fa-spinner fa-spin fa-2x" style="color:var(--color-primary);"></i></div>';

    fetch('/products/' + handle + '?section_id=main-product')
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = doc.querySelector('.quick-view-grid');
        
        if (grid) {
          modalBody.innerHTML = '';
          modalBody.appendChild(grid);
          
          const scripts = modalBody.querySelectorAll('script');
          scripts.forEach(oldScript => {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });
          
          const minusBtn = modalBody.querySelector('.qty-btn.minus');
          const plusBtn = modalBody.querySelector('.qty-btn.plus');
          const qtyInput = modalBody.querySelector('.qty-input');
          
          if (qtyInput) {
            if (minusBtn) {
              minusBtn.addEventListener('click', () => {
                let qty = parseInt(qtyInput.value, 10) || 1;
                if (qty > 1) {
                  qtyInput.value = qty - 1;
                  qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              });
            }
            if (plusBtn) {
              plusBtn.addEventListener('click', () => {
                let qty = parseInt(qtyInput.value, 10) || 1;
                if (qty < 10) {
                  qtyInput.value = qty + 1;
                  qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              });
            }
            
            qtyInput.addEventListener('change', () => {
              const basePriceEl = modalBody.querySelector('.main-total-price');
              if (basePriceEl) {
                const basePrice = parseInt(basePriceEl.getAttribute('data-base-price'), 10) || 0;
                const qty = parseInt(qtyInput.value, 10) || 1;
                basePriceEl.innerText = 'Rs. ' + ((basePrice * qty) / 100).toLocaleString('en-IN');
              }
            });
          }
        } else {
          modalBody.innerHTML = '<p style="padding:2rem;text-align:center;">Failed to load product details.</p>';
        }
      })
      .catch(err => {
        console.error('Quick View Error:', err);
        modalBody.innerHTML = '<p style="padding:2rem;text-align:center;">Failed to load product details.</p>';
      });
  });

  const closeModal = () => {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  };

  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });
}

// ============================================================
// MOBILE MENU TOGGLE
// ============================================================

function initMobileMenu() {
  const toggle = document.getElementById('mobile-toggle-nav');
  const navContent = document.getElementById('mobile-nav-content');
  const overlay = document.getElementById('mobile-overlay');
  const closeBtn = document.getElementById('mobile-close-btn');

  if (!toggle || !navContent) return;

  function openMenu() {
    navContent.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('menu-open');
  }

  function closeMenu() {
    navContent.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
    document.body.classList.remove('menu-open');
  }

  toggle.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  // Handle mobile drill-down for brand menus
  const navLinks = navContent.querySelectorAll('.has-dropdown > .nav-link, .has-subdropdown > a, .has-submenu > .dropdown-option, .mega-menu-list > .mega-menu-title');
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      // Only prevent default and toggle if we're on mobile view
      if (window.innerWidth < 1180) {
        const parentLi = link.parentElement;
        const submenu = parentLi.querySelector(':scope > .dropdown-menu, :scope > .subdropdown-menu, :scope > .shop-category-submenu, :scope > .sub-list');
        
        // If there is a submenu, prevent navigation and slide it in
        if (submenu) {
          e.preventDefault();
          
          // If back button doesn't exist in this submenu, create it
          if (!submenu.querySelector(':scope > .mobile-back-btn')) {
            const backLi = document.createElement('li');
            backLi.className = 'mobile-back-btn';
            
            // Build breadcrumb text
            let breadcrumb = [];
            let currentElement = link;
            
            // Extract text without the icon for the 'Go To' link
            const initialClone = link.cloneNode(true);
            const initialIcons = initialClone.querySelectorAll('i, svg');
            initialIcons.forEach(i => i.remove());
            const linkText = initialClone.textContent.trim();
            
            while (currentElement) {
              const currentClone = currentElement.cloneNode(true);
              const currentIcons = currentClone.querySelectorAll('i, svg');
              currentIcons.forEach(i => i.remove());
              breadcrumb.unshift(currentClone.textContent.trim());
              
              const parentSubmenu = currentElement.closest('.dropdown-menu, .subdropdown-menu, .shop-category-submenu, .sub-list');
              if (parentSubmenu) {
                const parentLi = parentSubmenu.closest('.has-dropdown, .has-subdropdown, .has-submenu, .mega-menu-list');
                if (parentLi) {
                  currentElement = parentLi.querySelector(':scope > a, :scope > .dropdown-option, :scope > .mega-menu-title');
                } else {
                  currentElement = null;
                }
              } else {
                currentElement = null;
              }
            }
            
            const breadcrumbText = breadcrumb.join(' > ');
            const linkHref = link.getAttribute('href') || '#';
            
            backLi.innerHTML = `
              <button aria-label="Go back">
                <i class="fa-solid fa-arrow-left"></i>
                <span>${breadcrumbText}</span>
              </button>
            `;
            
            backLi.querySelector('button').addEventListener('click', (ev) => {
              ev.preventDefault();
              ev.stopPropagation();
              submenu.classList.remove('slide-in-active');
              
              // Restore parent menu scroll position
              if (submenu.dataset.parentScrollTop !== undefined) {
                navContent.scrollTop = parseInt(submenu.dataset.parentScrollTop, 10);
              }
            });
            
            // Create "Go To [Category]" link
            const gotoLi = document.createElement('li');
            gotoLi.className = 'mobile-goto-btn';
            
            // Determine if this Go To link is the exactly active page
            const currentPath = window.location.pathname.replace(/\/$/, "");
            let targetPath = linkHref;
            try {
              targetPath = new URL(linkHref, window.location.origin).pathname.replace(/\/$/, "");
            } catch (e) {}
            
            const isActiveClass = (currentPath === targetPath && targetPath !== "" && targetPath !== "#") ? "active" : "";
            
            gotoLi.innerHTML = `<a href="${linkHref}" class="${isActiveClass}">Go To ${linkText} <i class="fa-solid fa-arrow-right"></i></a>`;
            
            // Insert goto link, then back link at the top
            submenu.insertBefore(gotoLi, submenu.firstChild);
            submenu.insertBefore(backLi, submenu.firstChild);
          }
          
          // Store current scroll position before sliding in
          submenu.dataset.parentScrollTop = navContent.scrollTop;
          
          submenu.classList.add('slide-in-active');
          
          // Scroll to top to view the new submenu
          navContent.scrollTop = 0;
        }
      }
    });
  });
}

// ============================================================
// CATEGORY SLIDER LOGIC
// ============================================================

function initCategorySlider() {
  const scrollAmount = 300; // Adjust as needed

  function updateSliderArrows(slider, prevBtn, nextBtn) {
    if (!slider || !prevBtn || !nextBtn) return;
    
    // If there is no overflow, hide both
    if (slider.scrollWidth <= slider.clientWidth + 5) {
      prevBtn.style.opacity = '0';
      prevBtn.style.pointerEvents = 'none';
      nextBtn.style.opacity = '0';
      nextBtn.style.pointerEvents = 'none';
      return;
    }
    
    // Tolerance of 20px for scroll snapping and padding
    if (slider.scrollLeft <= 20) {
      prevBtn.style.opacity = '0';
      prevBtn.style.pointerEvents = 'none';
    } else {
      prevBtn.style.opacity = '1';
      prevBtn.style.pointerEvents = 'auto';
    }
    
    if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 20) {
      nextBtn.style.opacity = '0';
      nextBtn.style.pointerEvents = 'none';
    } else {
      nextBtn.style.opacity = '1';
      nextBtn.style.pointerEvents = 'auto';
    }
  }

  // Key Categories Slider
  const keySlider = document.getElementById('key-cats-grid');
  const keyPrevBtn = document.getElementById('key-cat-prev');
  const keyNextBtn = document.getElementById('key-cat-next');

  if (keySlider && keyPrevBtn && keyNextBtn) {
    updateSliderArrows(keySlider, keyPrevBtn, keyNextBtn);
    keySlider.addEventListener('scroll', () => updateSliderArrows(keySlider, keyPrevBtn, keyNextBtn));
    window.addEventListener('resize', () => updateSliderArrows(keySlider, keyPrevBtn, keyNextBtn));
    window.addEventListener('load', () => updateSliderArrows(keySlider, keyPrevBtn, keyNextBtn));
    
    keyPrevBtn.addEventListener('click', () => {
      keySlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    keyNextBtn.addEventListener('click', () => {
      keySlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  // Flash Sale Slider
  const flashSlider = document.getElementById('flash-sale-grid');
  const flashPrevBtn = document.getElementById('flash-sale-prev');
  const flashNextBtn = document.getElementById('flash-sale-next');

  if (flashSlider && flashPrevBtn && flashNextBtn) {
    updateSliderArrows(flashSlider, flashPrevBtn, flashNextBtn);
    flashSlider.addEventListener('scroll', () => updateSliderArrows(flashSlider, flashPrevBtn, flashNextBtn));
    window.addEventListener('resize', () => updateSliderArrows(flashSlider, flashPrevBtn, flashNextBtn));
    window.addEventListener('load', () => updateSliderArrows(flashSlider, flashPrevBtn, flashNextBtn));
    
    flashPrevBtn.addEventListener('click', () => {
      flashSlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    flashNextBtn.addEventListener('click', () => {
      flashSlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  // Why Choose Us Slider
  const trustSlider = document.getElementById('trust-grid');
  const trustPrevBtn = document.getElementById('trust-prev');
  const trustNextBtn = document.getElementById('trust-next');

  if (trustSlider && trustPrevBtn && trustNextBtn) {
    updateSliderArrows(trustSlider, trustPrevBtn, trustNextBtn);
    trustSlider.addEventListener('scroll', () => updateSliderArrows(trustSlider, trustPrevBtn, trustNextBtn));
    window.addEventListener('resize', () => updateSliderArrows(trustSlider, trustPrevBtn, trustNextBtn));
    window.addEventListener('load', () => updateSliderArrows(trustSlider, trustPrevBtn, trustNextBtn));
    
    trustPrevBtn.addEventListener('click', () => {
      trustSlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    trustNextBtn.addEventListener('click', () => {
      trustSlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  // Testimonials Slider
  const testimonialSlider = document.getElementById('testimonials-slider');
  const testimonialPrevBtn = document.getElementById('testimonial-prev');
  const testimonialNextBtn = document.getElementById('testimonial-next');

  if (testimonialSlider && testimonialPrevBtn && testimonialNextBtn) {
    updateSliderArrows(testimonialSlider, testimonialPrevBtn, testimonialNextBtn);
    testimonialSlider.addEventListener('scroll', () => updateSliderArrows(testimonialSlider, testimonialPrevBtn, testimonialNextBtn));
    window.addEventListener('resize', () => updateSliderArrows(testimonialSlider, testimonialPrevBtn, testimonialNextBtn));
    window.addEventListener('load', () => updateSliderArrows(testimonialSlider, testimonialPrevBtn, testimonialNextBtn));
    
    testimonialPrevBtn.addEventListener('click', () => {
      testimonialSlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    testimonialNextBtn.addEventListener('click', () => {
      testimonialSlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  // Blog Slider
  const blogSlider = document.getElementById('blog-grid');
  const blogPrevBtn = document.getElementById('blog-prev');
  const blogNextBtn = document.getElementById('blog-next');

  if (blogSlider && blogPrevBtn && blogNextBtn) {
    updateSliderArrows(blogSlider, blogPrevBtn, blogNextBtn);
    blogSlider.addEventListener('scroll', () => updateSliderArrows(blogSlider, blogPrevBtn, blogNextBtn));
    window.addEventListener('resize', () => updateSliderArrows(blogSlider, blogPrevBtn, blogNextBtn));
    window.addEventListener('load', () => updateSliderArrows(blogSlider, blogPrevBtn, blogNextBtn));
    
    blogPrevBtn.addEventListener('click', () => {
      blogSlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    blogNextBtn.addEventListener('click', () => {
      blogSlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  // Shop By Category Slider
  const catSlider = document.getElementById('categories-grid');
  const catPrevBtn = document.getElementById('category-prev');
  const catNextBtn = document.getElementById('category-next');

  if (catSlider && catPrevBtn && catNextBtn) {
    updateSliderArrows(catSlider, catPrevBtn, catNextBtn);
    catSlider.addEventListener('scroll', () => updateSliderArrows(catSlider, catPrevBtn, catNextBtn));
    window.addEventListener('resize', () => updateSliderArrows(catSlider, catPrevBtn, catNextBtn));
    window.addEventListener('load', () => updateSliderArrows(catSlider, catPrevBtn, catNextBtn));
    
    catPrevBtn.addEventListener('click', () => {
      catSlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    catNextBtn.addEventListener('click', () => {
      catSlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  // Brands Slider
  const brandSlider = document.getElementById('brands-grid');
  const brandPrevBtn = document.getElementById('brand-prev');
  const brandNextBtn = document.getElementById('brand-next');

  if (brandSlider && brandPrevBtn && brandNextBtn) {
    updateSliderArrows(brandSlider, brandPrevBtn, brandNextBtn);
    brandSlider.addEventListener('scroll', () => updateSliderArrows(brandSlider, brandPrevBtn, brandNextBtn));
    window.addEventListener('resize', () => updateSliderArrows(brandSlider, brandPrevBtn, brandNextBtn));
    window.addEventListener('load', () => updateSliderArrows(brandSlider, brandPrevBtn, brandNextBtn));
    
    brandPrevBtn.addEventListener('click', () => {
      brandSlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    brandNextBtn.addEventListener('click', () => {
      brandSlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  // Popular Products Slider
  const popularSlider = document.getElementById('popular-products-grid');
  const popularPrevBtn = document.getElementById('popular-prev');
  const popularNextBtn = document.getElementById('popular-next');

  if (popularSlider && popularPrevBtn && popularNextBtn) {
    updateSliderArrows(popularSlider, popularPrevBtn, popularNextBtn);
    popularSlider.addEventListener('scroll', () => updateSliderArrows(popularSlider, popularPrevBtn, popularNextBtn));
    window.addEventListener('resize', () => updateSliderArrows(popularSlider, popularPrevBtn, popularNextBtn));
    window.addEventListener('load', () => updateSliderArrows(popularSlider, popularPrevBtn, popularNextBtn));
    
    popularPrevBtn.addEventListener('click', () => {
      popularSlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    popularNextBtn.addEventListener('click', () => {
      popularSlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  // Trending Products Slider
  const trendingSlider = document.getElementById('trending-products-grid');
  const trendingPrevBtn = document.getElementById('trending-prev');
  const trendingNextBtn = document.getElementById('trending-next');

  if (trendingSlider && trendingPrevBtn && trendingNextBtn) {
    updateSliderArrows(trendingSlider, trendingPrevBtn, trendingNextBtn);
    trendingSlider.addEventListener('scroll', () => updateSliderArrows(trendingSlider, trendingPrevBtn, trendingNextBtn));
    window.addEventListener('resize', () => updateSliderArrows(trendingSlider, trendingPrevBtn, trendingNextBtn));
    window.addEventListener('load', () => updateSliderArrows(trendingSlider, trendingPrevBtn, trendingNextBtn));
    
    trendingPrevBtn.addEventListener('click', () => {
      trendingSlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    trendingNextBtn.addEventListener('click', () => {
      trendingSlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
}


// ============================================================
// AUTH MODAL INTERACTIONS
// ============================================================

function initAuthModal() {
  const modal = document.getElementById('auth-modal');
  const accountBtn = document.getElementById('account-btn');
  const closeBtn = document.getElementById('close-auth-modal');
  
  if (!modal || !accountBtn || !closeBtn) return;
  
  // Check if button goes to login (i.e. not logged in)
  // Disabled per request to use default Shopify login instead
  /*
  if (accountBtn.hasAttribute('data-login-trigger')) {
    accountBtn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    });
  }
  */

  const closeModal = () => {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  };

  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Tabs
  const tabs = modal.querySelectorAll('.auth-tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => {
        t.classList.remove('active');
        t.style.borderBottomColor = 'transparent';
        t.style.color = 'var(--color-text-secondary)';
      });
      tab.classList.add('active');
      tab.style.borderBottomColor = 'var(--color-primary)';
      tab.style.color = 'var(--color-text-primary)';
      
      modal.querySelectorAll('.auth-form-wrapper').forEach(form => form.style.display = 'none');
      document.getElementById(tab.getAttribute('data-target')).style.display = 'block';
    });
  });
}

// ============================================================
// INITIALIZATION
// ============================================================

document.addEventListener('DOMContentLoaded', () => {
  // Dynamic content is now rendered via Liquid!

  // Initialize features
  startCountdown();
  initScrollAnimations();
  initHeaderScroll();
  initScrollTop();
  initProductTabs();
  initActiveNavLink();
  initSmoothScroll();
  initNewsletter();
  initSearch();
  initCustomDropdown();
  initCartInteractions();
  initWishlistInteractions();
  initQuickViewInteractions();
  initMobileMenu();
  initCategorySlider();
  initAuthModal();
  initDynamicSubmenu();
});

// Dynamically align sub-dropdowns to the left if near the right edge of screen
function initDynamicSubmenu() {
   function checkSubmenu(li) {
    const rect = li.getBoundingClientRect();
    // Since the main dropdown is 220px and the sub-dropdown is another 220px, 
    // we need at least 460px of space to the right to open normally.
    if (rect.right > window.innerWidth - 480) {
      li.classList.add('opens-left');
    } else {
      li.classList.remove('opens-left');
    }
  }
  const menuItems = document.querySelectorAll('.nav-menu li.has-dropdown');
  
  // Check immediately on load
  menuItems.forEach(li => checkSubmenu(li));
  
  // Check on hover
  menuItems.forEach(li => {
    li.addEventListener('mouseenter', function() {
      checkSubmenu(this);
    });
  });
   // Check on resize
  window.addEventListener('resize', () => {
    menuItems.forEach(li => checkSubmenu(li));
  });
}

// ============================================================
// CART DRAWER LOGIC
// ============================================================
document.addEventListener('DOMContentLoaded', () => {
  const cartBtns = document.querySelectorAll('.cart-btn-trigger');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-drawer-overlay');

  if (cartBtns.length > 0 && cartDrawer && cartOverlay) {
    cartBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openCartDrawer();
      });
    });

    cartOverlay.addEventListener('click', closeCartDrawer);
    
    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('.cart-drawer-close');
      if (closeBtn) {
        closeCartDrawer();
      }
    });

    // Handle quantity and remove inside drawer
    document.addEventListener('click', (e) => {
      // Quantity Buttons
      const qtyBtn = e.target.closest('.cart-drawer-qty-btn');
      if (qtyBtn) {
        const key = qtyBtn.getAttribute('data-key');
        const action = qtyBtn.getAttribute('data-action');
        const input = document.querySelector(`.cart-drawer-qty-input[data-key="${key}"]`);
        if (input) {
          let val = parseInt(input.value);
          if (action === 'plus') val++;
          else if (action === 'minus') val--;
          
          if (val < 0) val = 0;
          input.value = val;
          updateCartItemAjax(key, val);
        }
      }

      // Remove Button
      const removeBtn = e.target.closest('.cart-drawer-remove');
      if (removeBtn) {
        const key = removeBtn.getAttribute('data-key');
        updateCartItemAjax(key, 0);
      }
    });
  }
});

function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  if (drawer && overlay) {
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  if (drawer && overlay) {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
}

function updateCartDrawer() {
  const drawerBody = document.getElementById('CartDrawerContent');
  const drawerFooter = document.querySelector('.cart-drawer-footer');
  if (!drawerBody) return;

  drawerBody.classList.add('cart-drawer-is-loading');

  fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newBody = doc.getElementById('CartDrawerContent');
      if (newBody) {
        drawerBody.innerHTML = newBody.innerHTML;
      }
      
      const newHeader = doc.getElementById('CartDrawerHeader');
      const oldHeader = document.getElementById('CartDrawerHeader');
      if (newHeader && oldHeader) {
        oldHeader.innerHTML = newHeader.innerHTML;
      }
      
      const newFooter = doc.querySelector('.cart-drawer-footer');
      if (newFooter && drawerFooter) {
        drawerFooter.innerHTML = newFooter.innerHTML;
      }
      
      drawerBody.classList.remove('cart-drawer-is-loading');
    })
    .catch(err => {
      console.error('Error updating cart drawer:', err);
      drawerBody.classList.remove('cart-drawer-is-loading');
    });
}

function updateCartItemAjax(key, qty) {
  const drawerBody = document.getElementById('CartDrawerContent');
  if (drawerBody) drawerBody.classList.add('cart-drawer-is-loading');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: qty
    })
  })
  .then(res => res.json())
  .then(cart => {
    const cartCount = document.querySelector('#cart-btn .count');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.style.transform = 'scale(1.3)';
      setTimeout(() => cartCount.style.transform = 'scale(1)', 300);
    }
    updateCartDrawer();
  })
  .catch(err => {
    console.error('Error updating cart item:', err);
    if (drawerBody) drawerBody.classList.remove('cart-drawer-is-loading');
  });
}


// ============================================================
// FLOATING CONTACT WIDGET LOGIC
// ============================================================
document.addEventListener('DOMContentLoaded', () => {
  const contactToggle = document.getElementById('floating-contact-toggle');
  const contactMenu = document.getElementById('floating-contact-menu');
  
    if (contactToggle && contactMenu) {
      contactToggle.addEventListener('click', () => {
        contactMenu.classList.toggle('active');
        contactToggle.classList.toggle('active');
      });
    }
  });
  
  // ============================================================
  // CHECKOUT BUTTON LOADER LOGIC
  // ============================================================
  document.addEventListener('click', function(e) {
    const checkoutBtn = e.target.closest('button[name="checkout"]');
    if (checkoutBtn) {
      // Small delay to allow the form submission to register before manipulating the DOM
      setTimeout(() => {
        checkoutBtn.style.pointerEvents = 'none';
        checkoutBtn.style.opacity = '0.8';
        checkoutBtn.innerHTML = '<i class="fa-solid fa-circle-notch fa-spin"></i> Redirecting...';
      }, 50);
    }
  });

  // ============================================================
  // PRODUCT CARD QUICK ADD OVERLAY LOGIC
  // ============================================================
  document.addEventListener('click', function(e) {
    // 1. Open options absolute container
    const quickAddTrigger = e.target.closest('.quick-add-trigger');
    if (quickAddTrigger) {
      e.preventDefault();
      const form = quickAddTrigger.closest('form');
      if (form) {
        const optionsContainer = form.querySelector('.quick-add-options-container');
        if (optionsContainer) {
          optionsContainer.style.opacity = '1';
          optionsContainer.style.visibility = 'visible';
          optionsContainer.style.transform = 'translateY(0)';
          
          // Check availability for initially selected variant
          const firstSelectedVal = optionsContainer.querySelector('.quick-add-opt-val[style*="font-weight: 600"]');
          if (firstSelectedVal) {
             // Simulate a click on the active value to trigger availability check
             firstSelectedVal.click();
          }
        }
      }
      return;
    }

    // 2. Close options
    const closeBtn = e.target.closest('.close-quick-add');
    if (closeBtn) {
      const form = closeBtn.closest('form');
      if (form) {
        const optionsContainer = form.querySelector('.quick-add-options-container');
        if (optionsContainer) {
          optionsContainer.style.opacity = '0';
          optionsContainer.style.visibility = 'hidden';
          optionsContainer.style.transform = 'translateY(15px)';
        }
      }
      return;
    }

    // 3. Select Option Value
    const optValBtn = e.target.closest('.quick-add-opt-val');
    if (optValBtn) {
      const group = optValBtn.closest('.quick-add-option-group');
      
      // Update active state in this group
      group.querySelectorAll('.quick-add-opt-val').forEach(b => {
        b.style.fontWeight = 'normal';
        b.style.background = '#fff';
        b.style.color = 'var(--color-text-primary)';
        b.style.borderColor = 'var(--color-border)';
      });
      optValBtn.style.fontWeight = '600';
      optValBtn.style.background = 'var(--color-primary)';
      optValBtn.style.color = '#fff';
      optValBtn.style.borderColor = 'var(--color-primary)';
      
      // Update display text
      const selectedValText = group.querySelector('.selected-val');
      if (selectedValText) selectedValText.textContent = optValBtn.dataset.value;
      
      // Find matching variant ID
      const container = optValBtn.closest('.quick-add-options-container');
      const variantsJsonNode = container.querySelector('.product-variants-json');
      if (!variantsJsonNode) return;
      
      try {
        const variants = JSON.parse(variantsJsonNode.textContent);
        const selectedOptions = [];
        container.querySelectorAll('.quick-add-option-group').forEach(g => {
           const activeBtn = g.querySelector('.quick-add-opt-val[style*="font-weight: 600"]');
           if (activeBtn) selectedOptions.push(activeBtn.dataset.value);
           else selectedOptions.push(null);
        });
        
        const matchingVariant = variants.find(v => {
          return selectedOptions.every((val, i) => {
             if (val === null) return true;
             return v.options[i] === val;
          });
        });
        
        if (matchingVariant) {
           const form = container.closest('form');
           const hiddenInput = form.querySelector('.product-variant-id');
           if (hiddenInput) hiddenInput.value = matchingVariant.id;
           
           const confirmBtn = container.querySelector('.quick-add-confirm-btn');
           if (confirmBtn) {
             if (matchingVariant.available) {
               confirmBtn.textContent = 'Confirm Add';
               confirmBtn.disabled = false;
               confirmBtn.style.opacity = '1';
             } else {
               confirmBtn.textContent = 'Sold Out';
               confirmBtn.disabled = true;
               confirmBtn.style.opacity = '0.6';
             }
           }
        }
      } catch (err) {
        console.error('Error parsing variants:', err);
      }
      return;
    }

    // 4. Confirm Add to Cart
    const confirmBtn = e.target.closest('.quick-add-confirm-btn');
    if (confirmBtn) {
      const form = confirmBtn.closest('form');
      if (form) {
         const originalText = confirmBtn.innerHTML;
         confirmBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i>';
         confirmBtn.disabled = true;
         
         // Use a temp submit button to trigger existing AJAX cart submit handlers
         const tempSubmit = document.createElement('button');
         tempSubmit.type = 'submit';
         tempSubmit.style.display = 'none';
         form.appendChild(tempSubmit);
         tempSubmit.click();
         tempSubmit.remove();
         
         setTimeout(() => {
           confirmBtn.innerHTML = originalText;
           confirmBtn.disabled = false;
           const container = form.querySelector('.quick-add-options-container');
           if (container) {
             container.style.opacity = '0';
             container.style.visibility = 'hidden';
             container.style.transform = 'translateY(15px)';
           }
         }, 800);
      }
    }
  });

// ============================================================
// HIGHLIGHT ACTIVE SHOP BY CATEGORY MENU LINKS
// ============================================================
document.addEventListener('DOMContentLoaded', () => {
  const shopOptionsWrapper = document.getElementById('shop-dropdown-options');
  if (shopOptionsWrapper) {
    const currentPath = window.location.pathname.replace(/\/$/, "");
    const allLinks = shopOptionsWrapper.querySelectorAll('a[href]');
    
    allLinks.forEach(link => {
      let targetPath = link.getAttribute('href');
      try {
        targetPath = new URL(targetPath, window.location.origin).pathname.replace(/\/$/, "");
      } catch(e) {}
      
      if (currentPath === targetPath && targetPath !== "" && targetPath !== "/") {
        link.classList.add('active');
        
        // Parent sub-list title
        const parentSubList = link.closest('.sub-list');
        if (parentSubList) {
          const parentTitle = parentSubList.previousElementSibling;
          if (parentTitle && parentTitle.tagName === 'A') {
            parentTitle.classList.add('active');
          }
        }
        
        // Parent shop-category-item
        const parentCategoryItem = link.closest('.shop-category-item');
        if (parentCategoryItem) {
          const parentLink = parentCategoryItem.querySelector(':scope > a');
          if (parentLink) {
            parentLink.classList.add('active');
          }
        }
      }
    });
  }
});
